import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { FuseValidators } from '@fuse/validators';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Gtag } from 'angular-gtag';
import { ProfilesService } from '../profiles.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsComponent implements OnInit {
  contactUsForm: FormGroup
  hideProjectnumber = true
  submitted = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _profilesService: ProfilesService,
    // private _gtag: Gtag,
    private _fuseConfirmationService: FuseConfirmationService,
    private gtmService: GoogleTagManagerService,

  ) { }

  ngOnInit(): void {
    this.contactUsForm = this._formBuilder.group({
        name    : ['', Validators.required],
        email    : ['', [Validators.required, Validators.email]],
        phonenumber    : ['', Validators.required],
        subject    : ['', Validators.required],
        projectnumber    : [''],
        message    : ['', [Validators.required, Validators.maxLength(3000)]]

  }
  );

  this.subject.valueChanges.subscribe(res => {
console.log(res);
if (res == 'project') {


  this.projectnumber.addValidators([Validators.required]);
  this.projectnumber.updateValueAndValidity();

  this.hideProjectnumber = false;
  this.projectnumber.markAsTouched();

} else {
  this.projectnumber.removeValidators([Validators.required]);
  this.projectnumber.updateValueAndValidity();
  this.hideProjectnumber = true;


}
  });
  // this.contactUsForm.removeControl('projectnumber')


  // this._gtag.event('conversion', {
  //   send_to: 'AW-331179958/_g1MCO7bgKQDELbP9Z0B',
  //   value: 5.0,
  //   currency: 'CAD'
  // });
}

submit(): void {
  if (this.contactUsForm.valid) {
    this.submitted = true;
    console.log("valid");
    this._profilesService.submitContactUs(this.contactUsForm.value).subscribe(res => {
      console.log("res");
      console.log(res);
      if (!res.error) {
        // this.isEditable = false;
        // stepper.next();

        // this._gtag.event('success', { 
        //   method: 'onsite',
        //   event_category: 'contact_form',
        //   event_label: 'Contact form success'
        // });
        const gtmTag = {
          event: 'contact_form_success',
          method: 'onsite',
          event_category: 'contact_form',
          event_label: 'Contact form success'
      };
  
      this.gtmService.pushTag(gtmTag); 

        this._fuseConfirmationService.messageSentSuccess();
        this.contactUsForm.reset();
        
      } else {
        // this._gtag.event('failed', { 
        //   method: 'onsite',
        //   event_category: 'contact_form',
        //   event_label: 'Contact form faild'
        // });
        const gtmTag = {
          event: 'contact_form_failed',
          method: 'onsite',
          event_category: 'contact_form',
          event_label: 'Contact form faild'
      };
  
      this.gtmService.pushTag(gtmTag); 
      }

      // this._gtag.event('conversion', {send_to: 'AW-331179958/VeUwCMSj-6MDELbP9Z0B'});

      this.submitted = false;
    });
  } else {
    console.log("in valid");
    console.log(this.contactUsForm.errors);
  }
}

get email() {
  return this.contactUsForm.get('email');
}
get subject() {
  return this.contactUsForm.get('subject');
}
get projectnumber() {
  return this.contactUsForm.get('projectnumber');
}
get message() {
  return this.contactUsForm.get('message');
}
}
